import TableDateCell from '../../../../shared/components/table-cells/TableDateCell/TableDateCell';
import { Alignments } from '../../../../shared/components/ui/Table/enums/alignments.enum';
import { TableColumnDef } from '../../../../shared/components/ui/Table/models/table-column.model';
import { TextToColorMapModel } from '../../../../shared/models/text-to-color-map.model';
import { castTo } from '../../../../shared/utils/cast-to';
import { MapToText } from '../../../../shared/utils/map-to-text/map-to-text.util';
import { VehicleCampaignStatusEnum } from '../../../enums/vehicle-campaign-status.enum';
import { VehicleReportModel } from '../../../models/vehicle-report.model';
import { vehicleCampaignStatusMap } from './vehicle-campaign-status.map';

export const vehicleReportsTableColumnsDef: TableColumnDef[] = [
  {
    field: 'vin',
    headerName: 'Name',
    alignment: Alignments.LEFT,
  },
  {
    field: 'lastUpdated',
    headerName: 'Last Updated',
    alignment: Alignments.CENTER,
    valueGetter: row => {
      return (
        <TableDateCell
          date={castTo<VehicleReportModel>(row).lastUpdated}
        ></TableDateCell>
      );
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    alignment: Alignments.RIGHT,
    valueGetter: row =>
      MapToText<VehicleCampaignStatusEnum, TextToColorMapModel>({
        map: vehicleCampaignStatusMap,
        property: row.status as VehicleCampaignStatusEnum,
      }),
  },
];
